


export const checkIfProtectedKey=apiKey=> {
    const protectedKeys=['booking','restaurant_id','guestNumber','userPreferredSelection','userSetAddress','userOrderTime','asap'];
    return protectedKeys.includes(apiKey);
}